<script>
  import { useNavigate } from "svelte-navigator";
  const navigate = useNavigate();

  export let grid;
  let time = 30;

</script>

<main>
  <h4>Select a duration</h4>
  <fieldset>
    <button
      on:click={() => {
        if (time > 5) {
          time = time - 5;
        }
      }}
    >
      -5
    </button>
    <input type="number" pattern="\d*" min="0" bind:value={time} />
    <button
      on:click={() => {
        time = time + 5;
      }}
    >
      +5
    </button>
  </fieldset>

  <div class="buttons">
    <ion-button color="dark" on:click={() => navigate("/grid")}>
      <ion-icon name="arrow-back-outline" />Back
    </ion-button>
    <ion-button
      color="dark"
      disabled={time < 5}
      on:click={() => navigate(`/record/${grid}/${time}`)}
    >
      Start <ion-icon name="arrow-forward-outline" />
    </ion-button>
  </div>
</main>

<style>
  main {
    padding: 5px;
    display: flex;
    justify-content: space-between;
    flex-flow: column;
    height: 100vh;
  }
  main h4::before {
    content: "2/2";
    letter-spacing: 1px;
    background: var(--ion-color-light-tint);
    color: var(--ion-color-step-850);
    display: inline-block;
    width: 30px;
    height: 30px;
    font-size: 12px;
    vertical-align: middle;
    text-align: center;
    line-height: 30px;
    border-radius: 50%;
    margin-right: 15px;
  }

  main fieldset {
    flex: 1;
    border: none;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  main fieldset button {
    background: var(--ion-color-light-tint);
    color: var(--ion-color-step-850);
    font-size: 20px;
    border: none;
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }

  main fieldset input {
    text-align: center;
    font-size: 6rem;
    width: 120px;
    border: none;
    background: none;
    outline: none;
    color: var(--ion-color-step-550);
  }

  ion-button {
    margin-top: 20vh;
    width: fit-content;
    align-self: center;
  }
  div.buttons {
    text-align: center;
  }

</style>
